import {UserActions} from "../const/ActionsConst";

const initialState = {
    show: false,
    error: undefined,
    username: undefined,
    password: undefined,
    retypedPassword: undefined
};

const changePassword = (state = initialState, action) => {
    switch (action.type) {
        case UserActions.SHOW_CHANGE_PWD_WND:
            return {
                ...state,
                show: action.changePassword.show,
                username: action.changePassword.username
            };
        case UserActions.UPDATE_CHANGE_PWD_DATA:
            return {
                ...state,
                [action.changePassword.field]: action.changePassword.value,
            };
        case UserActions.CLEAR_CHANGE_PWD_DATA:
            return {
                ...state,
                show: false,
                error: undefined,
                username: undefined,
                password: undefined,
                retypedPassword: undefined
            };
        default:
            return state;
    }
};

export default changePassword;